import project_1 from "../../assets/project/project-1.png";
import project_2 from "../../assets/project/project-2.png";
import project_3 from "../../assets/project/project-3.png";
import project_4 from "../../assets/project/project-4.png";
import project_5 from "../../assets/project/project-5.png";
import project_6 from "../../assets/project/project-6.png";
import project_7 from "../../assets/project/project-7.png";
import project_8 from "../../assets/project/project-8.png";
import project_9 from "../../assets/project/project-9.png";
import project_10 from "../../assets/project/project-10.png";
import project_11 from "../../assets/project/project-11.png";
import project_12 from "../../assets/project/project-12.png";

const arrDataCourse = [
    {
        id: 1,
        name: "Project OFLIX Movie",
        course: "Frontend Newbie",
        img: project_1,
        link: "https://chinhlele.github.io/OFLIX-Movie/",
        special: true,
    },
    {
        id: 2,
        name: "Project shop mô hình liên minh",
        course: "Frontend cho design",
        img: project_2,
        link: "https://chinhlele.github.io/Olympus/",
        special: true,
    },
    {
        id: 3,
        name: "Project ecommerce Restful api",
        course: "Frontend newbie",
        img: project_4,
        link: "https://giahan1106.github.io/furniture_ecommerce",
        special: true,
    },
    {
        id: 4,
        name: "Project shop nội thất",
        course: "Frontend cho design",
        img: project_3,
        link: "https://fat.webdemo258.online/KT_WIT_2D003/NGUYEN_THI_KIEU_OANH/",
        special: true,
    },
    {
        id: 5,
        name: "Project shop trang sức",
        course: "React js",
        img: project_6,
        link: "https://react-jewelry.vercel.app/",
        special: true,
    },
    {
        id: 6,
        name: "Project shop phụ kiện",
        course: "Frontend cho design",
        img: project_5,
        link: "https://fat.webdemo258.online/KT_WIT_2D003/NGUYEN_ANH_THU/",
        special: false,
    },
    {
        id: 7,
        name: "Project trang sức",
        course: "Frontend cho design",
        img: project_7,
        link: "https://fat.webdemo258.online/KT_WIT_2D003/TRAN_THI_NHU_Y/",
        special: false,
    },
    {
        id: 8,
        name: "Project bán xe đạp",
        course: "React js",
        img: project_8,
        link: " https://react-bicycle-pi.vercel.app/",
        special: false,
    },
    {
        id: 9,
        name: "Project Flimlane",
        course: "Frontend newbie",
        img: project_9,
        link: " https://giahan1106.github.io/Filmlane/",
        special: false,
    },
    {
        id: 10,
        name: "Project nhà hàng",
        course: "Frontend cho design",
        img: project_10,
        link: "https://hieng55.github.io/DELICI-RESTAURANT/",
        special: true,
    },
    {
        id: 11,
        name: "Project dịch vụ cưới",
        course: "Frontend cho design",
        img: project_11,
        link: " https://tanghoangyen.github.io/Beauty-makeup-stylist/index.html",
        special: false,
    },
    {
        id: 12,
        name: "Project dịch vụ thuyền",
        course: "Frontend newbie",
        img: project_12,
        link: "https://firelua113.github.io/THTstore/home.html",
        special: false,
    },
];
export default arrDataCourse;
